import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { useDispatch, useSelector } from 'react-redux'
import { GetAuditsServices } from "../../../Redux/Services/Administrator/Audits"
import { Col, Row, DatePicker, Table, Input } from 'antd'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import {
    FilterOutlined,
    CalendarOutlined,
} from '@ant-design/icons'
import '../../../Styles/Routes/Audits.css'

const Audits = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const pageSize = 15
    const dispatch = useDispatch()
    const audits = useQuery({
        queryKey: ['audits'],
        queryFn : () => GetAuditsServices(dispatch),
        retry: 1,
        refetchOnWindowFocus : false,
    })

    const { 
        rex_data_audits, 
        rex_data_audits_clone, 
    } = useSelector(state => state.audits)

    const titleColumn = (columnName, column) => (
        <div className='Container-Title-Column-Approvals'>
            <span title={column}>{column}</span>
        </div>
    )

    const getColumnSearchProps = (dataIndex, texto) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
            <div
                style={{padding: 8,}}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input.Search
                    placeholder={`Buscar ${texto}`}
                    value={selectedKeys[0]}
                    onChange={async (e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                        confirm({
                            closeDropdown: false,
                        })
                    }}
                    style={{display: 'block'}}
                />
            </div>
        ),
        filterIcon: () => (<FilterOutlined style={{color: '#fff'}} />),
        onFilter: (value, record) => {
            let valueData
            if(dataIndex.length == 3){
                if(record[dataIndex[0]]){
                    if(record[dataIndex[0]][dataIndex[1]]){
                        valueData = record[dataIndex[0]][dataIndex[1]][dataIndex[2]]
                    }
                }
            }else if(dataIndex.length == 2){
                if(record[dataIndex[0]]){
                    valueData = record[dataIndex[0]][dataIndex[1]]
                }
            }else if(dataIndex.length == 1){
                valueData = record[dataIndex[0]]
            }

            return valueData ? valueData.toString().toLowerCase().includes(value.toLowerCase()) : false
        }
    })

    const getColumnDateProps = (dataIndex, nameColumn) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <DatePicker
                    allowClear={true}
                    onChange={(value)=> {
                        const date_value = value ? format(new Date(value.$d), 'dd/MM/yyyy') : null
                        setSelectedKeys(date_value ? [date_value] : [])
                        confirm({
                            closeDropdown: false,
                        })
                    }}
                />
            </div>
        ),
        filterIcon: () => (<CalendarOutlined style={{color: '#fff'}} />),
        onFilter: (value, record) => {
            const valueData = format(parseISO(record[dataIndex[0]]), 'dd/MM/yyyy')

            return valueData ? valueData.toString().toLowerCase().includes(value.toLowerCase()) : false
        }
    })

    const columns = [
        {
            title: '#',
            dataIndex: 'key',
            render: (_, __, index) => <div title={index + 1 + (currentPage - 1) * pageSize}>{index + 1 + (currentPage - 1) * pageSize}</div>,
            width: '50px',
            align:'center'
        },
        {
            title: titleColumn('tpunombre', 'TIPO DE PERFIL'),
            dataIndex: 'usuusuarios',
            ...getColumnSearchProps(['usuusuarios', 'tputiposusuarios', 'tpunombre'], 'Tipo de Perfil'),
            sorter: (a, b) => {
                const columnA = a?.usuusuarios?.tputiposusuarios?.tpunombre || ''
                const columnB = b?.usuusuarios?.tputiposusuarios?.tpunombre || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) =>  <div title={record.usuusuarios ? record.usuusuarios.tputiposusuarios?.tpunombre : ''}>
                                        {record.usuusuarios ? record.usuusuarios.tputiposusuarios?.tpunombre : ''}
                                    </div>,
            width: '120px'
        },
        {
            title: titleColumn('pernombrecompleto', 'NOMBRE COMPLETO'),
            dataIndex: 'usuusuarios.perpersonas',
            ...getColumnSearchProps(['usuusuarios', 'perpersonas', 'pernombrecompleto'], 'Nombre Completo'),
            sorter: (a, b) => {
                const columnA = a?.usuusuarios?.perpersonas?.pernombrecompleto || ''
                const columnB = b?.usuusuarios?.perpersonas?.pernombrecompleto || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_,record) => <div title={record.usuusuarios ? record.usuusuarios.perpersonas?.pernombrecompleto : ''}>{record.usuusuarios ? record.usuusuarios.perpersonas?.pernombrecompleto : ''}</div>,
            width: '150px'
        },
        {
            title: titleColumn('usuusuario', 'CORREO'),
            dataIndex: 'usuusuarios.usuusuario',
            ...getColumnSearchProps(['usuusuarios', 'usuusuario'], 'Correo'),
            sorter: (a, b) => {
                const columnA = a?.usuusuarios?.usuusuario || ''
                const columnB = b?.usuusuarios?.usuusuario || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.usuusuarios?.usuusuario}>{record.usuusuarios?.usuusuario}</div>,
            width: '120px'
        },
        {
            title: titleColumn('auddescripcion', 'MÓDULO'),
            dataIndex: 'auddescripcion',
            ...getColumnSearchProps(['auddescripcion'], 'Modulo'),
            sorter: (a, b) => {
                const columnA = a?.auddescripcion || ''
                const columnB = b?.auddescripcion || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.auddescripcion}>{record.auddescripcion}</div>,
            width: '100px'
        },
        {
            title: titleColumn('audruta', 'RUTA'),
            dataIndex: 'audruta',
            ...getColumnSearchProps(['audruta'], 'Ruta'),
            sorter: (a, b) => {
                const columnA = a?.audruta || ''
                const columnB = b?.audruta || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.audruta}>{record.audruta}</div>,
            width: '100px'
        },
        {
            title: titleColumn('audaccion', 'ACCIÓN'),
            dataIndex: 'audaccion',
            ...getColumnSearchProps(['audaccion'], 'Acción'),
            sorter: (a, b) => {
                const columnA = a?.audaccion || ''
                const columnB = b?.audaccion || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.audaccion}>{record.audaccion}</div>,
            width: '100px'
        },
        {
            title: titleColumn('audjsonentrada', 'ENTRADA'),
            dataIndex: 'audjsonentrada',
            ...getColumnSearchProps(['audjsonentrada'], 'Entrada'),
            sorter: (a, b) => {
                const columnA = a?.audjsonentrada || ''
                const columnB = b?.audjsonentrada || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.audjsonentrada}>{record.audjsonentrada}</div>,
            width: '100px'
        },
        {
            title: titleColumn('audjsonsalida', 'SALIDA'),
            dataIndex: 'audjsonsalida',
            ...getColumnSearchProps(['audjsonsalida'], 'Salida'),
            sorter: (a, b) => {
                const columnA = a?.audjsonsalida || ''
                const columnB = b?.audjsonsalida || ''
                let responseSorter = false
                if(columnA && columnB){
                    responseSorter = columnA.localeCompare(columnB)
                }

                return responseSorter
            },
            showSorterTooltip: false,
            render: (_, record) => <div title={record.audjsonsalida}>{record.audjsonsalida}</div>,
            width: '100px'
        },
        {
            title: titleColumn('created_at', 'FECHA Y HORA'),
            dataIndex: 'created_at',
            ...getColumnDateProps(['created_at'], 'Fecha y hora'),
            showSorterTooltip: false,
            render: (_, record) =>  
                <div title={record.created_at ? moment(record.created_at).format('DD/MM/YYYY h:mm a') : ''}>
                    {record.created_at ? moment(record.created_at).format('DD/MM/YYYY h:mm a') : ''}
                </div>,
            width: '120px'
        },
    ]

	return (
		<Row>
			<Col span={24} style={{ margin: '10px 0' }}>
				<div style={{ fontSize: '20px', fontWeight: 'bold' }}>Control de Auditorias</div>
			</Col>
            <Col span={24}>
                <Table 
                    pagination={{
                        position: ["topRight", "none"],
                        pageSize: pageSize,
                        size: 'small',
                        onChange: (page) => setCurrentPage(page),
                        showTotal: (total) => `Total: ${total} registros`
                    }}
                    scroll={{
                        x: '1000px',
                        y: '370px',
                    }}
                    loading={audits.isPending}
                    columns={columns}
                    dataSource={rex_data_audits_clone} 
                    className="Table-Audits"
                    size='small'
                />
            </Col>
		</Row>
	)
}

export default Audits